import { useMemo } from 'react';

import { getActiveAssignedLineIds } from '@core/role-actions/assigned-lines.utils';
import { useAppSelector } from '@core/redux/hooks';
import { useGetPolicyAssignedLines } from '@features/production/policy/policy.slice';

const ASSIGNED_LINES_PAGINATION = {
  pageNumber: 1,
  pageSize: 1000
};

const ASSIGNED_LINES_ORDER_BY = {
  attribute: 'line.code',
  descending: false
};

type UseAssignedLineIdsOptions = {
  skip?: boolean;
};

export function useAssignedLineIds(options?: UseAssignedLineIdsOptions) {
  const user = useAppSelector((s) => s.user);
  const userId = user?.info?.id ?? '';

  const { data, loading, refetch } = useGetPolicyAssignedLines({
    variables: {
      selectedUserID: userId,
      pagination: ASSIGNED_LINES_PAGINATION,
      OrderBy: ASSIGNED_LINES_ORDER_BY,
      keywordSearch: null
    },
    skip: options?.skip || !userId
  });

  const assignedLineIds = useMemo(() => {
    const fromQuery = getActiveAssignedLineIds(
      data?.salesforce?.searchUserAssignedLines?.items ?? []
    );

    if (fromQuery.length) {
      return fromQuery;
    }

    return getActiveAssignedLineIds(
      user?.info?.editableChargesLines?.map((line) => ({
        lineID: line.lineID,
        status: 'Active'
      })) ?? []
    );
  }, [data, user?.info?.editableChargesLines]);

  return { assignedLineIds, loading, refetch };
}
